"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNormForEmployeeInDateRange = exports.getNormForDateRange = exports.calculateBusinessDays = void 0;
var moment_1 = __importDefault(require("moment"));
var datetime_1 = require("./datetime");
var areDatesEqual = function (firstDate, secondDate) {
    return (0, moment_1.default)(firstDate).format('YYYY-MM-DD') === (0, moment_1.default)(secondDate).format('YYYY-MM-DD');
};
var getFromToForBusinessDays = function (firstDate, secondDate) {
    var result = {
        from: (0, moment_1.default)(firstDate),
        to: (0, moment_1.default)(secondDate),
        areDatesEqual: areDatesEqual(firstDate, secondDate),
    };
    if (result.areDatesEqual)
        return result;
    var shouldSwitchDates = result.to.isBefore(result.from);
    if (shouldSwitchDates) {
        result.to = (0, moment_1.default)(firstDate);
        result.from = (0, moment_1.default)(secondDate);
    }
    return result;
};
var adjustFromDate = function (date) {
    var isSaturday = date.day() === 6;
    var isSunday = date.day() === 0;
    if (isSaturday) {
        // Move date to next week monday
        date.day(8);
    }
    else if (isSunday) {
        // Move date to current week monday
        date.day(1);
    }
};
var adjustToDate = function (date) {
    var isSaturday = date.day() === 6;
    var isSunday = date.day() === 0;
    if (isSaturday) {
        // Move date to current week friday
        date.day(5);
    }
    else if (isSunday) {
        // Move date to previous week friday
        date.day(-2);
    }
};
var calculateBusinessDays = function (firstDate, secondDate) {
    var _a = getFromToForBusinessDays(firstDate, secondDate), from = _a.from, to = _a.to, areDatesEqual = _a.areDatesEqual;
    if (areDatesEqual)
        return 0;
    var adjust = 0;
    adjustFromDate(from);
    adjustToDate(to);
    var fromWeek = from.week();
    var toWeek = to.week();
    var areWeeksDifferent = fromWeek !== toWeek;
    if (areWeeksDifferent) {
        // Check if second date's year is different from first date's year
        if (toWeek < fromWeek) {
            toWeek += (0, moment_1.default)(to).subtract(1, 'year').weeksInYear();
        }
        // Calculate adjust value to be substracted from difference between two dates
        adjust = -2 * (toWeek - fromWeek);
    }
    return to.diff(from, 'days') + adjust + 1;
};
exports.calculateBusinessDays = calculateBusinessDays;
var getStartEndDates = function (startDate, endDate, empConditions) {
    var _a = empConditions || {}, hire_date = _a.hire_date, release_date = _a.release_date;
    var start = (0, moment_1.default)(startDate).startOf('day').format('YYYY-MM-DD');
    var end = (0, moment_1.default)(endDate).startOf('day').format('YYYY-MM-DD');
    var startStr = hire_date ? (0, datetime_1.getMaxDate)(hire_date, start) : start;
    var endStr = release_date ? (0, datetime_1.getMinDate)(end, release_date) : end;
    return { startStr: startStr, endStr: endStr };
};
var getNormForDateRange = function (startDate, endDate, holidays) {
    var _a = getStartEndDates(startDate, endDate), startStr = _a.startStr, endStr = _a.endStr;
    var workingDays = (0, exports.calculateBusinessDays)(startStr, endStr);
    var relevantHolidays = holidays.filter(function (h) { return h.day !== 7 && h.freeFromWork && h.date >= startStr && h.date <= endStr; });
    var totalWorkingDays = workingDays - relevantHolidays.length;
    return totalWorkingDays * 8;
};
exports.getNormForDateRange = getNormForDateRange;
var getNormForEmployeeInDateRange = function (startDate, endDate, holidays, empConditions) {
    var _a = getStartEndDates(startDate, endDate, empConditions), startStr = _a.startStr, endStr = _a.endStr;
    var workNorm = (0, exports.getNormForDateRange)(startStr, endStr, holidays);
    if (!empConditions)
        return workNorm;
    var weeklyWorkingHours = empConditions.weekly_working_minutes / 60;
    return workNorm * (weeklyWorkingHours / 40);
};
exports.getNormForEmployeeInDateRange = getNormForEmployeeInDateRange;
